import script from "./BlacklistingCommentTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlacklistingCommentTable.vue?vue&type=script&lang=ts&setup=true"

import "./BlacklistingCommentTable.vue?vue&type=style&index=0&id=6bb1d7be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bb1d7be"]])

export default __exports__